import { baseApi } from "./baseApi";

const PAYMENT_INTEGRATION_BASE_URL = "/paymentIntegration";

export const paymentIntegrationApi = baseApi.injectEndpoints({
  tagTypes: ["PaymentIntegration"],

  endpoints: (builder) => ({
    getPaymentIntegrationList: builder.query({
      query: (params) => ({ url: `${PAYMENT_INTEGRATION_BASE_URL}`, params }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "PaymentIntegration", _id })),
              { type: "PaymentIntegration", id: "LIST" },
            ]
          : [{ type: "PaymentIntegration", id: "LIST" }],
    }),

    getPaymentIntegrationDDL: builder.query({
      query: (params) => ({
        url: `${PAYMENT_INTEGRATION_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "PaymentIntegration", _id })),
              { type: "PaymentIntegration", id: "DDL" },
            ]
          : [{ type: "PaymentIntegration", id: "DDL" }],
    }),

    getPaymentIntegrationDetail: builder.query({
      query: (id) => `${PAYMENT_INTEGRATION_BASE_URL}/${id}`,
      providesTags: (result, error, { _id }) => [
        { type: "PaymentIntegration", _id },
        { type: "PaymentIntegration", id: "LIST" },
      ],
    }),

    createPaymentIntegration: builder.mutation({
      query: (payload) => ({
        url: PAYMENT_INTEGRATION_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "PaymentIntegration", id: "LIST" },
        { type: "PaymentIntegration", _id },
      ],
    }),

    updatePaymentIntegration: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;

        return {
          url: `${PAYMENT_INTEGRATION_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "PaymentIntegration", _id },
        { type: "PaymentIntegration", id: "LIST" },
      ],
    }),

    getCurrentEntityPaymentIntegrations: builder.query({
      query: () => `${PAYMENT_INTEGRATION_BASE_URL}/entity/current`,
      providesTags: [{ type: "PaymentIntegration", id: "ENTITY_LIST" }],
    }),

    getActivePaymentProviders: builder.query({
      query: () => `${PAYMENT_INTEGRATION_BASE_URL}/entity/active-providers`,
      providesTags: [{ type: "PaymentIntegration", id: "ACTIVE_PROVIDERS" }],
    }),
  }),
});

export const {
  useGetPaymentIntegrationListQuery,
  useLazyGetPaymentIntegrationListQuery,
  useGetPaymentIntegrationDDLQuery,
  useLazyGetPaymentIntegrationDDLQuery,
  useGetPaymentIntegrationDetailQuery,
  useCreatePaymentIntegrationMutation,
  useUpdatePaymentIntegrationMutation,
  useGetActivePaymentProvidersQuery,
} = paymentIntegrationApi;
